import AdminClerksHeader from "./components/admin-clerks-header";
import AdminClerksList from './components/admin-clerks-list';
import useAdminClerks, { AdminClerksState } from './hooks/use-admin-clerks';

export default function AdminClerks() {
	const adminClerksState: AdminClerksState = useAdminClerks();

	return (
		<div className="flex flex-col flex-grow w-full">
			<AdminClerksHeader state={adminClerksState} />
			<AdminClerksList state={adminClerksState} />
		</div>
	);
}
